#root {
	margin: 0 auto;
	width: 100%;
}

main, header, footer {
	padding: 0 2rem;
}

main.annotator {
	padding: 0;
}